import React from "react";
import SponsorsContent from "../function-components/SponsorsContent";

function Sponsor() {
  return (
    <>
      <SponsorsContent />
    </>
  );
}

export default Sponsor;
